import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  standalone: false,
  name: 'bringozDate'
})
export class BringozDatePipe implements PipeTransform {

  constructor(@Inject('splitService') private splitService) {}

  transform(object: any, ref: string, displayTime: boolean = false, timeZoneId?: string): string {
    if (object && object[ref]) {
      const format = this.getFormat(displayTime);
      return this.formatDate(object[ref], format, timeZoneId);
    } else {
      return '---';
    }
  }

  private getFormat(displayTime: boolean): string {
    const dateConfig = this.splitService.getDateAndTimeConfig();
    let format = dateConfig.date;
    if (displayTime) {
      format += ', ' + dateConfig.time;
    }
    return format;
  }

  private formatDate(date: any, format: string, timeZoneId?: string): string {
    if (timeZoneId) {
      return moment(date).tz(timeZoneId).format(format);
    } else {
      return moment(date).format(format);
    }
  }
}
